import { render, staticRenderFns } from "./BoxCard.vue?vue&type=template&id=192b5bd4&scoped=true&"
import script from "./BoxCard.vue?vue&type=script&lang=js&"
export * from "./BoxCard.vue?vue&type=script&lang=js&"
import style0 from "./BoxCard.vue?vue&type=style&index=0&id=192b5bd4&prod&lang=scss&"
import style1 from "./BoxCard.vue?vue&type=style&index=1&id=192b5bd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192b5bd4",
  null
  
)

export default component.exports